
  Vue.component('abb-menu', {
    props: {
      activeMenu: { type: String, required: true },
      entityCategory: { type: Number, default: 9999 },
      requireRegistration: { type: Boolean, default: false },
      showRegistrationOnly: { type: Boolean, default: false },
      showFreeSubscription: { type: Boolean, default: false },
      seekerRelationshipId: { type: Number, default: -1 },
      hideRelationship: { type: Boolean, default: false },
      companyPartnerId: { type: String },
      campaign: { type: String },
      coupon: { type: String },
      subType: { type: String },
      employees: { type: Number }
    },
    data() {
      return {
        selectedCoupon: this.coupon,
        subscriptionCoupon: {},
        notificationOnExit: true,
        specialOffer: false,
        showHint: false,
        showArrowHint: false,
        seekerFrom: null,
        seekerRelationship: null,
        seekerAlreadyRegistered: null,
        selectedEntityCategory: this.entityCategory,
        requestContactFullName: null,
        userId: '',
        pageflow: '',
        paymentInstallment: false,
        showPaymentInstallment: false,
        groupPaymentInstallment: true,
        groupedPaymentInstallmentStatus: {},
        currentPage: 1, // Debug Mettere 3 per dati fatturazione altrimenti 1
        currentEmployeesNumber: -1,
        showEmployeesNumber: false,
        currentSelected: (this.seekerRelationshipId > 0 && !this.hideRelationship) || this.campaign ? -9999 : -1, // Se la registrazione è su invito di default seleziona abbonamento GRATIS
        originalMenuItems: [],
        error: false,
        employeesNumber: [
          { id: 1, label: 'Fino a 14 dipendenti', shortLabel: '< 15' },
          { id: 2, label: 'Da 15 a 75 dipendenti', shortLabel: '15 - 75' },
          { id: 3, label: 'DA 76 a 200 dipendenti', shortLabel: '76 - 200' },
          { id: 4, label: 'Oltre 200 dipendenti', shortLabel: '> 200' }
        ],
        entityCategoriesList: [
          { code: 'Candidate', id: 0, label: '', userRole: 2 },
          { code: 'Company', id: 1, label: 'le aziende con più di 200 dipendenti', userRole: 1 },
          { code: 'TrainingAgency', id: 2, label: 'gli enti formativi', userRole: 3 },
          { code: 'WorkAgency', id: 3, label: 'le agenzie del lavoro', userRole: 7 },
          { code: 'Subscription', id: 4, label: '', userRole: 9999 },
          { code: 'VoluntaryAssociation', id: 5, label: 'le associazioni di volontariato', userRole: 4 },
          { code: 'College', id: 6, label: 'le università', userRole: 5 },
          { code: 'School', id: 7, label: 'le scuole', userRole: 6 },
          { code: 'Nothing', id: 9999, label: 'nessuna selezione', userRole: 9999 }
        ],
        dynFormConfigRegisterRecaptcha: [
          {
            id: 7,
            fieldName: 'recaptcha',
            inputType: 'recaptcha',
            label: 'recaptcha',
            validators: [{ type: 'required', message: 'Captcha non valido' }]
          }
        ],
        formInterfaces: {},
        formStoredValues: {}
      }
    },
    template: '#abb-menu',
    computed: {
      hasCoupon() {
        return Object.keys(this.subscriptionCoupon).length > 0
      },
      isWidgetOnly() {
        return this.subType && this.subType.toLowerCase() === 'widget'
      },
      forceLogin() {
        // return !this.campaign
        return true
      },
      showEmployeesNumberField() {
        return false // this.campaign // || this.seekerRelationshipId > 0
      },
      dynamicFormEmployeesNumber() {
        const self = this
        return [
          {
            id: 100,
            fieldName: 'employeesNumber',
            label: 'Numero dipendenti',
            inputType: self.showEmployeesNumberField ? 'radio' : 'hidden',
            validators: [
              {
                type: 'regex',
                regex: '^[1234]$',
                message: 'Campo obbligatorio'
              },
              {
                type: 'required'
              }
            ],
            options: this.employeesNumber.map(item => ({
              id: item.id,
              label: item.shortLabel,
              valueIfChecked: `${item.id}`
            }))
          }
        ]
      },
      registrationOnlyMenuItem() {
        return {
          Id: -9999,
          Amount: 0,
          Vat: 0,
          Code: 'OnlyRegistration',
          Name: 'Solo Registrazione',
          Description: 'Solo Registrazione',
          RenewCode: 'OnlyRegistration',
          RenewName: 'Solo Registrazione',
          RenewDescription: 'Solo Registrazione',
          Duration: -1,
          EntityCategory: -1,
          Visible: true,
          MustHaveWidget: false,
          Active: true,
          EmployeesNumber: -1,
          DemoMode: this.currentEmployeesNumber === -1
        }
      },
      userRole() {
        return this.entityCategoriesList.find(item => item.id === this.selectedEntityCategory).userRole
      },
      entityCategoryDescription() {
        return this.entityCategoriesList.find(x => x.id === this.selectedEntityCategory).label
      },
      showContactForm() {
        return (
          (this.currentEmployeesNumber === 4 &&
            this.selectedEntityCategory === 1 &&
            !(this.subscriptionCoupon.Id && this.filteredMenuItems.length > 0)) ||
          ([2, 3, 6, 7].includes(this.selectedEntityCategory) && !this.specialOffer)
        )
      },
      showCoupon() {
        return (
          !this.specialOffer && !this.campaign && this.currentPageCode === 'piano' && this.selectedEntityCategory === 1
        )
      },
      showPageInfo() {
        let retVal = true
        if (this.showContactForm || this.selectedEntityCategory === 5) retVal = false
        return retVal
      },
      pages() {
        let retVal = []
        let pages = {
          categorySelection: [
            {
              id: 0,
              code: 'profilo',
              label: 'Selezione Profilo',
              title: 'Scegli il tuo profilo',
              subTitle: 'Trova la giusta soluzione per le tue necessità',
              titleIcon: 'fa-tags'
            }
          ],
          firstPage: [
            {
              id: 10,
              code: 'piano',
              label: 'Selezione Piano',
              title: this.specialOffer
                ? 'Il piano riservato a te'
                : this.isWidgetOnly
                ? 'Inizia subito'
                : 'Scegli il piano che fa per te',
              subTitle: this.specialOffer
                ? `E' stata creata un'offerta personalizzata`
                : this.isWidgetOnly
                ? 'Evita le sanzioni e rispetta la privacy'
                : 'Trova la giusta soluzione per le tue necessità',
              titleIcon: 'fa-star'
            }
          ],
          privateDealRequest: [
            {
              id: 10,
              code: 'piano',
              label: 'Invio Richiesta',
              title: 'Scegli il piano che fa per te',
              subTitle: 'Trova la giusta soluzione per le tue necessità',
              titleIcon: 'fa-star'
            }
          ],
          billingPaymentData: [
            {
              id: 20,
              code: 'fatturazione',
              label: 'Dati fatturazione',
              title: 'Completa i dati di fatturazione',
              subTitle: `Compila tutti i campi obbligatori * e prosegui con l'acquisto`,
              titleIcon: 'fa-address-card'
            },
            this.selectedMenuItem && this.selectedMenuItem.Amount > 0
              ? {
                  id: 30,

                  code: 'pagamento',
                  label: 'Selezione pagamento',
                  title: 'Scegli il metodo di pagamento',
                  subTitle: `Accetta i termini e le condizioni del servizio e concludi l'acquisto`,
                  titleIcon: 'fa-credit-card'
                }
              : {
                  id: 30,

                  code: 'pagamento',
                  label: 'Termini e condizioni',
                  title: 'Termini e condizioni',
                  subTitle: `Accetta i termini e le condizioni del servizio e concludi l'acquisto`,
                  titleIcon: 'fa-clipboard-list-check'
                }
          ],
          registrationData: [
            {
              id: 15,
              code: 'registrazione',
              label: 'Dati anagrafici',
              title: 'Completa i dati anagrafici',
              subTitle: `Compila tutti i campi obbligatori *`,
              titleIcon: 'fa-address-card'
            }
          ],
          confirmRegistrationData: [
            {
              id: 16,
              code: 'confermaRegistrazione',
              label: 'Conferma dati anagrafici',
              title: 'Completa la registrazione',
              subTitle: `Attenzione, la registrazione non è ancora terminata`,
              titleIcon: 'fa-address-card'
            }
          ],
          confirmPrivateDealRequest: [
            {
              id: 14,
              code: 'confermaRichiestaInformazioni',
              label: 'Conferma richiesta informazioni',
              title: 'Messaggio inviato con successo',
              subTitle: `${
                this.requestContactFullName ? `Gentile ${this.requestContactFullName}, i` : 'I'
              }l tuo messagio è stato inviato correttamente<br>Ti ringraziamo per averci contattato`,
              titleIcon: 'fa-address-card'
            }
          ]
        }
        pages = {
          ...pages,
          gdprPages: [
            ...[...pages.firstPage, ...pages.registrationData].map(page => ({
              ...page,
              title: 'Metti al sicuro la tua azienda',
              subTitle: `Evita le multe per non aver rispettato la privacy`,
              bottomTitle: `LearK raccoglie e gestisce i tuoi CV in regola con il GDPR.<br> Garantisci alla tua azienda il massimo della sicurezza nel trattamento dei dati personali. <span class="bold">Bastano pochi secondi.</span>`,
              titleImage: '/images/homepage/logo-gdpr.svg'
            })),
            ...pages.billingPaymentData.map(page => ({ ...page, titleImage: '/images/homepage/logo-gdpr.svg' }))
          ]
        }

        if (this.selectedEntityCategory === 5) retVal = pages.registrationData.concat(pages.confirmRegistrationData)
        else if (this.showContactForm) retVal = pages.privateDealRequest.concat(pages.confirmPrivateDealRequest)
        else if (this.campaign) retVal = [...pages[`${this.campaign}Pages`]]
        else if (this.seekerRelationshipId > 0)
          retVal = [...pages.firstPage, ...pages.registrationData, ...pages.billingPaymentData]
        else {
          retVal = pages.firstPage
          if (this.seekerRelationshipId === -1) retVal = retVal.concat(pages.billingPaymentData)
          if (this.showRegistrationOnly) retVal = retVal.concat(pages.registrationData)
          if (this.currentSelected === -9999)
            retVal = [...pages.firstPage, ...pages.registrationData, ...pages.confirmRegistrationData]
        }

        if (this.selectedEntityCategory === 9999) retVal = pages.categorySelection.concat(retVal)

        return retVal.sort((a, b) => (a.id > b.id ? 1 : -1))
      },
      currentPageCode() {
        return this.pages[this.currentPage - 1].code
      },
      havePendingSubscription() {
        return !!this.$slots.PendingSubscription
      },
      isExpiringCurrentSubscription() {
        return !!this.$slots.ExpiringCurrentSubscription
      },
      filteredMenuItems() {
        // let retVal = this.showRegistrationOnly ? [this.registrationOnlyMenuItem] : []
        let retVal = this.showFreeSubscription ? [this.registrationOnlyMenuItem] : []

        const defaultEmployeesNumberToShow = 2
        const employeesNumber =
          this.currentEmployeesNumber === -1 ? defaultEmployeesNumberToShow : this.currentEmployeesNumber

        let selectedVal = this.originalMenuItems.filter(
          item => item.EmployeesNumber === employeesNumber
          /* 3 = SubscriptionDurationType.Year | 5 = SubscriptionDurationType.AnnualByInstallments */
        )

        if (!this.groupPaymentInstallment) {
          selectedVal = selectedVal.filter(item => item.Duration === (this.paymentInstallment ? 5 : 3))
        } else {
          selectedVal = selectedVal
            .map(item => {
              const key = `${item.EntityCategory}|${item.EmployeesNumber}|${item.MustHaveWidget}|${item.WidgetOnly}`
              const { paymentInstallment } = this.groupedPaymentInstallmentStatus[key]
              if (item.Duration === (paymentInstallment ? 5 : 3)) {
                return {
                  ...item,
                  ShowPaymentInstallment: this.groupedPaymentInstallmentStatus[key].elements > 1
                }
              }
            })
            .filter(item => item)
        }
        selectedVal.sort((a, b) => {
          const keyA = `${a.EntityCategory}|${a.EmployeesNumber}|${a.MustHaveWidget}|${a.WidgetOnly}`
          const keyB = `${b.EntityCategory}|${b.EmployeesNumber}|${b.MustHaveWidget}|${b.WidgetOnly}`
          return keyA > keyB ? 1 : keyB > keyA ? -1 : 0
        })

        if (this.currentEmployeesNumber === -1) {
          selectedVal = selectedVal.map(item => ({ ...item, DemoMode: true }))
        }

        retVal = retVal.concat(selectedVal)
        return retVal
      },

      selectedMenuItem() {
        let retVal
        if (this.currentSelected !== -1) {
          retVal = this.filteredMenuItems.find(item => item.Id === this.currentSelected)
        }
        return retVal
      },
      registrationDefaultValue() {
        let retVal = {}
        const key = 'RegisterData'
        if (this.seekerRelationship) {
          retVal.txtRegisterCompanyFirstname = this.seekerRelationship.ContactFirstName
          retVal.txtRegisterCompanyLastname = this.seekerRelationship.ContactLastName
          retVal.txtRegisterCompanyCompanyName = this.seekerRelationship.ContactCompany
          retVal.txtRegisterCompanyEmail = this.seekerRelationship.ContactEmail
        }
        if (key in this.formStoredValues) {
          retVal = { ...retVal, ...this.formStoredValues[key] }
        }
        retVal.employeesNumber = `${this.currentEmployeesNumber}`
        return retVal
      },
      termsDefaultValue() {
        let retVal = {}
        const key = 'RegistrationTermsAndConditions'
        if (key in this.formStoredValues) {
          retVal = { ...this.formStoredValues[key] }
        }
        return retVal
      }
    },
    watch: {},
    methods: {
      handleCoupon(couponCode) {
        this.selectedCoupon = couponCode.toUpperCase()
        const hfCoupon = document.getElementById('hfCoupon')
        hfCoupon.value = couponCode
        this.loadSubscription(this.selectedEntityCategory)
      },
      handlePaymentInstallment(key, value) {
        this.groupedPaymentInstallmentStatus[key].paymentInstallment = value
        this.groupedPaymentInstallmentStatus = { ...this.groupedPaymentInstallmentStatus }
      },
      nextPage(e, pageNumber) {
        if (this.currentPage < this.pages.length) {
          this.pageflow = ''
          if (pageNumber) {
            setTimeout(() => (this.currentPage = pageNumber), 100)
          } else {
            setTimeout(() => this.currentPage++, 100)
          }
        } else {
          console.log('Ultima Pagina')
        }
      },
      previousPage(e, pageNumber) {
        this.pageflow = '-back'
        if (pageNumber) {
          setTimeout(() => (this.currentPage = pageNumber), 100)
        } else if (this.currentPage > 1) {
          setTimeout(() => this.currentPage--, 100)
        }
      },
      selectMenuItem(item) {
        const self = this
        this.showHint = false
        this.showArrowHint = false
        // const currentSelected = this.currentSelected == item.Id ? -1 : item.Id
        const previousSelected = this.currentSelected
        this.paymentInstallment = item.PaymentInstallment
        const currentSelected = item.Id
        this.currentSelected = -1
        if (!item.DemoMode) {
          this.currentSelected = currentSelected
          if (currentSelected !== -1 && item.Id !== this.registrationOnlyMenuItem.Id) {
            window.ChangeSubscriptionTypeFunction(item.Id, item.MustHaveWidget)
          } else {
            window.ChangeSubscriptionTypeFunction(null, null)
          }
          if (currentSelected !== -1) {
            setTimeout(() => this.nextPage(), 0)
          }
        } else {
          const el = this.$refs.employeesSelector
          const elRect = el.getBoundingClientRect()
          // console.log(el, elRect)
          if (elRect.top < 0) {
            if (window.scrollY === 0) el.scrollIntoView({ behavior: 'smooth' })
            else window.scrollTo({ top: 220, behavior: 'smooth' })
            setTimeout(() => (self.showHint = true), 400)
          } else {
            this.showHint = true
          }
          setTimeout(() => {
            self.showHint = false
            setTimeout(() => {
              self.showArrowHint = true
            }, 500)
          }, 1300)

          // EventBus.$emit('vnShow', {
          //  type: 'danger',
          //  message: `Per poter selezionare un piano è necessario indicare il numero di dipendenti della tua azienda`
          // })
        }
      },
      clickPaymentInstallment(installment) {
        this.paymentInstallment = installment
        this.currentSelected = -1
      },
      changeEmployeesNumber(id) {
        this.currentEmployeesNumber = this.currentEmployeesNumber === id ? -1 : id
        this.currentSelected = -1
        this.showArrowHint = false
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      },
      validateTermsAndConditions() {
        const key = 'TermsAndConditions'
        if (this.formInterfaces[key].validate()) {
          this.notificationOnExit = false
          this.goToPayment()
        }
      },
      validateRegisterData() {
        const self = this
        const key = 'RegisterData'
        const keyTerms = 'RegistrationTermsAndConditions'
        const keyRecaptcha = 'RegistrationRecaptcha'
        if (
          this.formInterfaces[key].validate() &&
          this.formInterfaces[keyTerms].validate() &&
          this.formInterfaces[keyRecaptcha].validate()
        ) {
          self.formStoredValues = {
            ...self.formStoredValues,
            ...{ [key]: { ...self.formInterfaces[key].getValues() } },
            ...{ [keyTerms]: { ...self.formInterfaces[keyTerms].getValues() } }
          }

          let postValues = {
            ...self.formStoredValues[key],
            ...self.formStoredValues[keyTerms],
            ...self.formInterfaces[keyRecaptcha].getValues()
          }
          if (self.seekerRelationshipId > 0) {
            postValues.seekerRelationshipId = self.seekerRelationshipId
          }
          postValues.userRole = this.userRole
          if (this.companyPartnerId) postValues.companyPartnerId = this.companyPartnerId
          if (this.campaign)
            postValues = {
              ...postValues,
              subscriptionOriginId: this.campaign,
              subscriptionOriginEntity: 22 /* MarketingCampaign */
            }
          axios
            .post(
              `/api/v1/subscriptions/new-registration/${this.forceLogin}${this.userId ? `/${this.userId}` : ''}`,
              postValues
            )
            .then(response => {
              const { data } = response
              if (data.saveResponse || data.notifyResponse) {
                // responsevalue = response.substring(3)
              }
              if (data.saveResponse) {
                EventBus.appUserId = data.userId
                this.userId = data.userId
                EventBus.$emit('vnShow', {
                  type: 'success',
                  message: `Registrazione effettuata correttamente .`
                })
                self.nextPage()
              }
            })
            .catch(error => {
              let intError = error
              const responseError = this.getErrorResponse(error)
              console.log(responseError)
              if ([401, 491].includes(responseError.status)) {
                self.handleSessionExpired()
              } else if (responseError.recaptcha) {
                intError = responseError.recaptcha
                this.formInterfaces[keyTerms].validate()
              } else {
                EventBus.$emit('vnShow', {
                  autoClose: false,
                  type: 'danger',
                  message: `Le modifiche non sono state salvate: ${intError}`
                })
              }
            })
            .then(() => {
              // always executed
            })
        }
      },
      getErrorResponse(error) {
        const retVal = { ...error }
        if (error.response) {
          if (error.response.data && error.response.data.error) {
            retVal.error = error.response.data.error
          }
          retVal.status = error.response.status
        }
        return retVal
      },
      sendContactRequest() {
        const key = 'ContactRequest'
        const self = this
        let postValues
        if (this.formInterfaces[key].validate() && this.formInterfaces[key].fieldsAreChange()) {
          const formValue = self.formInterfaces[key].getValues()
          postValues = {
            issubscription: true,
            FullName: formValue.txtContactRequestFullName,
            Email: formValue.txtContactRequestEmail,
            Phone: formValue.txtContactRequestPhone,
            Company: formValue.txtContactRequestCompany,
            Message: formValue.txtContactRequestMessage,
            AcceptPrivacy: formValue.chkContactRequestPrivacy,
            AcceptMarketing: false,
            AcceptThirdPart: false
          }

          axios
            .post(`/api/v1/subscriptions/send-private-deal-contact/${self.selectedEntityCategory}`, postValues)
            .then(response => {
              self.requestContactFullName = postValues.FullName
              EventBus.$emit('vnShow', {
                type: 'success',
                message: `La richiesta è stata inviata correttamente.`
              })
              self.nextPage()
            })
            .catch(error => {
              EventBus.$emit('vnShow', {
                type: 'danger',
                message: `Le modifiche non sono state salvate: ${error}`
              })
            })
            .then(() => {
              // always executed
            })
        }
      },

      validateBillingData() {
        const key = 'BillingData'
        const self = this
        if (this.formInterfaces[key].validate()) {
          if (!this.formInterfaces[key].fieldsAreChange()) {
            self.nextPage()
          } else if (this.formInterfaces[key].fieldsAreChange()) {
            const formValue = self.formInterfaces[key].getValues()
            Object.keys(formValue).forEach(prop => {
              const elem = document.getElementById(prop)
              if (elem) elem.value = formValue[prop]
            })
            const postValues = {
              issubscription: true,
              name: formValue.txtBillingDataSeekerCompany,
              email: formValue.txtBillingDataSeekerEmail,
              vat: formValue.txtBillingDataSeekerVATNumber,
              taxcode: formValue.txtBillingDataSeekerTaxCode,
              phone: formValue.txtBillingDataSeekerPhone,
              mobile: formValue.txtBillingDataSeekerMobile,
              street: formValue.txtBillingAddressSeekerStreet,
              city: formValue.txtBillingAddressSeekerCity,
              country: formValue.txtBillingAddressSeekerCountry,
              district: formValue.txtBillingAddressSeekerDistrict,
              postalcode: formValue.txtBillingAddressSeekerPostalCode,
              foreignpostalcode: formValue.txtBillingAddressSeekerPostalCode,
              sdi: formValue.txtBillingDataSeekerSDI,
              pec: formValue.txtBillingDataSeekerPec,
              description: formValue.txtDescription,
              sectordata: formValue.jsonSectorData,
              acceptedgdprinfo: false,
              acceptedtermsandconditions: false,
              selectedsubscriptiontype: self.currentSelected,
              currenturl: window.location.href
            }

            axios
              .post(`/Account/SeekerService.asmx/saveSeekerBillingData`, postValues)
              .then(response => {
                const { d: data } = response.data
                if (data.startsWith('OK|') || data.startsWith('KO|')) {
                  // responsevalue = response.substring(3)
                }
                if (data.startsWith('OK|')) {
                  EventBus.$emit('vnShow', {
                    type: 'success',
                    message: `Le modifiche ai dati di fatturazione sono state salvate correttamente.`
                  })
                  self.nextPage()
                }
              })
              .catch(error => {
                const intError = error
                const responseError = this.getErrorResponse(error)
                if ([401, 491].includes(responseError.status)) {
                  self.handleSessionExpired()
                } else {
                  EventBus.$emit('vnShow', {
                    type: 'danger',
                    message: `Le modifiche non sono state salvate: ${error}`
                  })
                  self.nextPage()
                }
              })
              .then(() => {
                // always executed
              })
          }
        }
      },
      beforeEnter: () => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      afterLeave: () => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
        // Store.commit("setPageTransition", "default");
      },
      handleRegisterDataChange(field) {
        const self = this
        if (field.fieldName === 'employeesNumber') this.currentEmployeesNumber = parseInt(field.value, 10)
        const key = 'RegisterData'
        self.formStoredValues = {
          ...self.formStoredValues,
          ...{
            [key]: { ...self.formStoredValues[key], [field.fieldName]: field.value }
          }
        }
      },
      paymentChange(field) {
        Array.from(document.getElementsByName('ctl00$cphElements$rblPaymentType')).find(
          item => item.value === field.value
        ).checked = true
      },
      termsAndConditionsChange(field) {
        document.getElementsByName(`ctl00$cphElements$${field.fieldName}`)[0].checked = field.value === 'true'
      },
      goToPayment() {
        document.getElementsByName(`ctl00$cphElements$btnNext`)[0].click()
      },
      stopAll(event) {
        event.stopPropagation()
        event.preventDefault()
        return false
      },
      changeCategory(id) {
        this.selectedEntityCategory = id
        this.loadSubscription(id)
      },
      loadSubscription(entityCategory) {
        const self = this
        const postData = {
          entityCategory: `${entityCategory}`,
          couponCode: self.selectedCoupon
        }
        if (this.subType && ['widget', 'premium'].includes(this.subType)) {
          postData.widgetOnly = this.isWidgetOnly
        }
        axios
          .post(`/api/v1/subscriptions/entity-category/`, postData)
          .then(response => {
            const { specialOffer, subscriptionBuyType: data, subscriptionCoupon } = response.data
            // self.currentSelected = data.currentSelected
            self.specialOffer = specialOffer
            if (subscriptionCoupon) self.subscriptionCoupon = subscriptionCoupon
            const uniqueEmployeesNumber = [...new Set(data.map(item => item.EmployeesNumber))]
            self.currentEmployeesNumber =
              self.currentEmployeesNumber != -1
                ? self.currentEmployeesNumber
                : uniqueEmployeesNumber.length === 1
                ? uniqueEmployeesNumber[0]
                : data.filter(i => i.EmployeesNumber > 0).length > 0
                ? -1
                : 0
            self.showPaymentInstallment = !(
              data.filter(i => i.Duration === 5).length === 0 || data.filter(i => i.Duration === 3).length === 0
            )
            self.showEmployeesNumber = uniqueEmployeesNumber.length > 1

            self.paymentInstallment = !(data.filter(i => i.Duration === 3).length > 0)
            self.originalMenuItems = data
            if (data.length === 0) this.currentSelected = -9999
            self.groupedPaymentInstallmentStatus = {}
            data.forEach(item => {
              const key = `${item.EntityCategory}|${item.EmployeesNumber}|${item.MustHaveWidget}|${item.WidgetOnly}`
              if (self.groupedPaymentInstallmentStatus.hasOwnProperty(key)) {
                self.groupedPaymentInstallmentStatus[key].elements++
              } else self.groupedPaymentInstallmentStatus[key] = { elements: 1, paymentInstallment: false }
            })
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            // always executed
          })
      },
      loadRelationship(id) {
        const self = this
        axios
          .get(`/api/v1/seekers-relationships/seeker/${self.seekerRelationshipId}`)
          .then(response => {
            const { data } = response
            self.seekerFrom = data.seeker
            self.seekerRelationship = data.seekerRelationship
            self.seekerAlreadyRegistered = data.alreadyRegistered
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            // always executed
          })
      },
      handleSessionExpired() {
        EventBus.$emit('vnPopup', {
          type: 'danger',
          message: `<p><b>La sessione è scaduta</b></p><p>La pagina verrà ricaricata per permettere di effettuare nuovamente il login</p>`,
          actions: [
            {
              label: 'OK',
              icon: 'fa-check-circle',
              action: () => {
                window.location.reload()
              },
              style: 'danger'
            }
          ]
        })
      },
      handleWindowLeave(event) {
        if (this.notificationOnExit) {
          event.preventDefault()
          return (event.returnValue = 'Le modifiche apportate potrebbero non essere salvate')
        }
      }
    },
    mounted() {
      if (this.entityCategory !== 9999) {
        this.loadSubscription(this.entityCategory)
      }
      if (this.seekerRelationshipId > 0) {
        this.loadRelationship()
      }
      window.onbeforeunload = this.handleWindowLeave
    }
  })
